<template>
  <div>
    <el-dialog
      :title="$t('lang.阈值设置')"
      :visible.sync="dialogVisible"
      width="748"
      :before-close="handleClose"
      :append-to-body="true"
    >
      <el-form
        :model="thresForm"
        :rules="rules"
        ref="thresRef"
        label-width="120"
        :inline="true"
        :hide-required-asterisk="true"
        :style="{ paddingLeft: $i18n.locale == 'zh-CN' ? '85px' : '55px' }"
      >
        <el-form-item :label="$t('lang.功率门限阈值')" prop="thresholdValue">
          <el-input
            v-model="thresForm.thresholdValue"
            :placeholder="$t('lang.请输入功率门限阈值')"
          >
            <span slot="suffix">kW</span>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="readLoading" @click="onClickRead">
            {{ $t("lang.读取") }}
          </el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="writeLoading" @click="onClickSet">
            {{ $t("lang.设置") }}
          </el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  components: {},
  data() {
    return {
      dialogVisible: false,
      readLoading: false,
      writeLoading: false,
      pointId: 0,
      thresForm: {
        thresholdValue: "",
      },
      rules: {
        thresholdValue: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value) {
                return callback(new Error(this.$t("lang.请输入功率门限阈值")));
              }
              callback();
            },
            trigger: "blur",
          },
        ],
      },
    };
  },
  mounted() {},
  methods: {
    ...mapActions({
      readPowerLimit: "ZD_ReadPowerLimit",
      writePowerLimit: "ZD_WritePowerLimit",
    }),
    showDialog(pointId) {
      this.dialogVisible = true;
      this.pointId = pointId;
    },
    async onClickSet() {
      try {
        await this.$refs.thresRef.validate();
        this.writeLoading = true;
        let res = await this.writePowerLimit({
          value: {
            pointId: this.pointId,
            power: Number(this.thresForm.thresholdValue) * 1000,
          },
        });
        if (res.success !== 1) return;
        this.$message({
          message: this.$t("lang.设置成功"),
          type: "success",
        });
      } catch {
      } finally {
        this.writeLoading = false;
      }
    },
    async onClickRead() {
      try {
        this.readLoading = true;
        let res = await this.readPowerLimit({ pointId: this.pointId });
        if (res.success !== 1) return;
        this.thresForm.thresholdValue = Number(res.value) / 1000;
        this.$message({
          message: this.$t("lang.读取成功"),
          type: "success",
        });
      } catch {
      } finally {
        this.readLoading = false;
      }
    },
    handleClose() {
      this.dialogVisible = false;
      this.$refs.thresRef.resetFields();
    },
  },
};
</script>

<style scoped lang='less'>
.el-form {
  .el-form-item {
    margin-right: 20px;
  }
  .el-input {
    width: 300px;
  }
  /deep/ .el-input__suffix-inner {
    color: #333;
  }
}
</style>